import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { createUserOrderCms, getProducts } from "../../Services/ProductService";

const AddUserProduct = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        user_id: data?.data?.user_id,
        product_id: [{ product_id: "", quantity: 1 }],
    });
    const [loader, setLoader] = useState(false);
    const [status, setStatus] = useState([]);

    const handleAddField = (e) => {
        e.preventDefault();
        const newField = { product_id: "", quantity: 1 };
        let data = reqData?.product_id;
        data?.push(newField);
        setReqData({ ...reqData, product_id: data });
    };

    const handleRemoveField = (e, id) => {
        e.preventDefault();

        let data = reqData?.product_id;
        const updatedFields = data.filter((field, index) => index !== id);
        setReqData({ ...reqData, product_id: updatedFields });
    };

    const handleInputChange = (id, field, value) => {
        const updatedFields = reqData?.product_id?.map((obj, index) =>
            index === id ? { ...obj, [field]: value } : obj
        );
        setReqData({ ...reqData, product_id: updatedFields });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createUserOrderCms(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getStatusCall = async () => {
        let { ok, data } = await getProducts({});
        if (ok) {
            setStatus(data?.records);
        }
    };

    const getSelectedProduct = (id) => {
        const product = status.find((obj) => obj?.id == id);
        return product;
    };

    const getPricing = () => {
        let string = "";
        if (reqData?.product_id[0]?.product_id) {
            let actual_price = 0;
            let discount_price = 0;

            for (let i = 0; i < reqData?.product_id?.length; i++) {
                let product = getSelectedProduct(reqData?.product_id[i]?.product_id);
                if (product) {
                    let { discount_type, price, discount, tax_percentage } = product;
                    let total_price = 0;
                    let tax_amount = 0;
                    if (product.discount_type) {
                        if (discount_type == 'flat') {
                            total_price = reqData?.product_id[i]?.quantity * (price - discount);
                        } else {
                            total_price = reqData?.product_id[i]?.quantity * (price - (price * discount / 100));
                        }
                    } else {
                        total_price = reqData?.product_id[i]?.quantity * price;
                    }
                    if (tax_percentage) {
                        tax_amount = total_price * tax_percentage / 100;
                    }

                    discount_price += total_price + tax_amount;
                    actual_price += price * reqData?.product_id[i]?.quantity;
                }
            }
            string += `Actual Amount: ${actual_price} / Payable Amount: ${discount_price}`;
        }
        return string;
    };

    useEffect(() => {
        getStatusCall();
    }, []);

    return (
        <div
            className="modal modal-fullscreen custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">Add User Product</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {reqData?.product_id?.map((obj, index) => {
                            return (
                                <div className="modal-body">
                                    <div className="bank-inner-details">
                                        <div className="row">
                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label>
                                                        {`Product ${index + 1}`}
                                                        {index !== 0 && <button
                                                            data-bs-dismiss="modal"
                                                            className="btn bank-cancel-bt"
                                                            onClick={(e) => handleRemoveField(e, index)}
                                                            style={{ color: "red", marginBottom: "2px" }}
                                                        >
                                                            Remove
                                                        </button>}
                                                    </label>
                                                    <select required value={reqData?.product_id[index]?.product_id} onChange={(e) => handleInputChange(index, "product_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                        <option value={""} selected>Select</option>
                                                        {status?.map(obj =>
                                                            <>
                                                                <option value={obj?.id}>{obj?.name}</option>
                                                            </>
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>{`Quantity ${index + 1}`}</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Quantity"
                                                        required
                                                        value={obj?.quantity}
                                                        onChange={(e) => handleInputChange(index, "quantity", e?.target?.value)}
                                                    />
                                                </div>
                                                {reqData?.product_id[index]?.product_id &&
                                                    <>
                                                        <div className="form-group">
                                                            <label className="me-2">{`Price: ${getSelectedProduct(reqData?.product_id[index]?.product_id)?.price}`}</label>
                                                            <label className="me-2">{`Discount: ${getSelectedProduct(reqData?.product_id[index]?.product_id)?.discount} ${getSelectedProduct(reqData?.product_id[index]?.product_id)?.discount_type !== "flat" ? "%" : "(Flat)"}`}</label>
                                                            <label className="me-2">{`Tax: ${getSelectedProduct(reqData?.product_id[index]?.product_id)?.tax_percentage}%`}</label>
                                                        </div>
                                                    </>
                                                }
                                                {index == reqData?.product_id?.length - 1 && <div className="form-group">
                                                    <label>Payment Mode</label>
                                                    <select required value={reqData?.payment_mode} onChange={(e) => setReqData({ ...reqData, payment_mode: e.target.value })} class="form-select" aria-label="Default select example">
                                                        <option value={""} selected>Select</option>
                                                        <option value={"UPI"}>{"UPI"}</option>
                                                        <option value={"Cash"}>{"Cash"}</option>
                                                    </select>
                                                </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                        {Boolean(getPricing()?.length) && <label style={{ margin: "10px" }}>{getPricing()}</label>}
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn me-2"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                                <button
                                    onClick={handleAddField}
                                    className="btn bank-cancel-btn me-2"
                                    disabled={loader}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form >
        </div >
    );
};

export default AddUserProduct;